// ***__***_________  BIBLIOTECAS _________ ***__***
import { Component, Inject, AfterViewInit, Optional, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DateTimePickerDirective } from '../../../directives/datepicker.directive';

// ***__***_________  SERVICOS _________ ***__***
import { HttpClientCustom } from '../../../services/http-client';
import { AuthenticationService } from '../../../services/authentication.service';

// ***__***_________  VARIAVEIS GLOBAIS _________ ***__***
import { ALIAS, LANGUAGE } from '../../../constants/global';

// ***__***_________  MODELOS _________ ***__***
import { ReturnStatusHtml } from '../../../models/returnStatus';
import { ErrorTreatmentFunctions } from '../../../modules/treatments.module';

// ***__***_________  MODALS _________ ***__***
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { HttpEvent } from '@angular/common/http';

declare var Functions: any;

export class DocumentHistoryModalParam {
  constructor(
    /// nome a colocar no titulo da modal, se for null = 'STATE_OPTIONS'
    @Optional() public Title?: string,

    /// contexto da operação
    @Optional() public Context?: string,

    @Optional() public Data?: DocumentHistoryReturnParam[],

    //For backend
    @Optional() public UseBackend?: boolean,
    @Optional() public URL?: string,
    @Optional() public DocumentID?: number,
    @Optional() public TotalNetVisible?: boolean,
    @Optional() public newTabInsteadOfRedirect?: boolean
  ) { }
}

export class DocumentHistoryReturnParam {
  constructor(
    @Optional() public DocumentID: number,
    @Optional() public DocumentName: string,
    @Optional() public DocumentDate?: string,
    @Optional() public CreatedByName?: string,
    @Optional() public Total?: number,
    @Optional() public TotalNetAmount?: number,
  ) { }
}

const ORDER_URL = "orderPurchase"
const ORDERSALE_URL = "orderSale"

@Component({
    templateUrl: './document-history-modal.html',
    standalone: false
})
export class DocumentHistoryModalComponent implements AfterViewInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();

  parameters: DocumentHistoryModalParam = new DocumentHistoryModalParam(); // parametros que vai receber do componente que esta a abrir a modal
  table: any;

  constructor(public dialogRef: MatDialogRef<DocumentHistoryModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data: DocumentHistoryModalParam,
    private _http: HttpClientCustom,
    private _errorTreat: ErrorTreatmentFunctions,
    private _authenticationService: AuthenticationService,
    private _router: Router,
  ) {
    this.parameters = data;
    this.parameters.Data || []
  }

  ngAfterViewInit() {
    let aoColumns, columnDefs = [];
    let that = this;

      // colunas por defeito
    aoColumns = [
      { 'data': 'DocumentID', 'visible': false },
      { 'data': 'DocumentDate', 'class': 'verticalMiddle', 'render': function (data: any, type: string, full: any, meta: any) { return DateTimePickerDirective.convertToString(data, true); } }, // 0
      { 'data': 'DocumentName', 'class': 'verticalMiddle', 'render': function (data: any, type: string, full: any, meta: any) 
        { 
          //HREF é utilizado no click da bola do rato
          if (that._authenticationService.session.permissions.some(x => x.Name == "PurchasesOrders") && that.parameters.Context == "ORDERS"){
            return '<a class="table-order-link" href="' + ALIAS + ORDER_URL + "/" + full.DocumentID + '" onclick="return false;" data-id="' + full.DocumentID + '"><span>' + data + ' </span></a>';
          }

          if (that._authenticationService.session.permissions.some(x => x.Name == "SalesOrders") && that.parameters.Context == "ORDERSSALES"){
            return '<a class="table-order-link" href="' + ALIAS + ORDERSALE_URL + "/" + full.DocumentID + '" onclick="return false;" data-id="' + full.DocumentID + '"><span>' + data + ' </span></a>';
          }

          return data;
        } 
      },
      { 'data': 'TotalNetAmount', 'class': 'verticalMiddle', 'visible': this.parameters.TotalNetVisible === true },
      { 'data': 'Total', 'class': 'verticalMiddle text-right' }, //BilledAmount
      { 'data': 'CreatedByName', 'class': 'verticalMiddle' },
    ];

    columnDefs.push({ 'targets': '_all', 'ordering': false }); // nao permitir ordenar pelas colunas
    columnDefs.push({ 'targets': [-1], 'orderable': false }); // nao permitir ordenar pelas colunas

    // construir a tabela sem dados
    this.table = Functions.datatablesWithDataSet('#tableHistory', this.parameters.Data || [], [],
      aoColumns, columnDefs, ALIAS + 'assets/resources/datatables-' + LANGUAGE + '.json', 1, false, false, true, false, 'asc'); // ultimo campo para alterar DOM

    //let that = this;

    this.table.on('draw', function () {
      let btnsEdit = document.getElementsByClassName('table-order-link');
      for (let btnEdit of Array.from(btnsEdit)) {
        btnEdit.addEventListener('click', function (ev: any) {
          that.goToOrder(this.getAttribute('data-id'));
        });
      }
    });

    if (this.parameters.UseBackend){
      this.table.processing(true); // colocar o div a informar que esta a processar
      this._http.getBackend(this.parameters.URL).subscribe((x: any) => {
        this.table.processing(false);
        if (x.ReturnStatus.Successfull && x.ReturnStatus.ReturnObject){
          this.parameters.Data = [];
          if (x.ReturnStatus.ReturnObject?.length > 0){
            if (this.parameters.Context == "ORDERS" || this.parameters.Context == "ORDERSSALES"){
              this.parameters.Data = x.ReturnStatus.ReturnObject.map(x => new DocumentHistoryReturnParam(x.ID ,x.DocumentNumber,x.DocumentDate,x.CreatedByName,x.TotalPayableAmount, x.TotalNetAmount))
            }
            if (this.table) {
              this.table.clear(); // limpar a tabela
              this.table.rows.add(this.parameters.Data).draw(); // colocar os novos dados
            }
          }
        }
      })
    }
  }

  //Utilizado no click
  goToOrder(id: any): void {
    const URL = '/' + (this.parameters.Context == "ORDERSSALES" ? ORDERSALE_URL : ORDER_URL) + '/' + id;

    if (this.parameters.newTabInsteadOfRedirect){
      const url = this._router.serializeUrl(
          this._router.createUrlTree([URL])
      );
      window.open(url, "_blank");
      return;
    }

    this.dialogRef.close();
    this._router.navigate([URL]);
  }

  

  ngOnDestroy() { }
}
